export default __webpack_public_path__ + "static/t-04-7e4e4302e1dbce5e1e3d5d55a704f95f.png";